/**
 * @author Ezzo
 * Added on behalf of SAS 
 * I guess better to do this way ! update validation functionality on one Place is a blast ;)
 */
export const validateEtisalatPhone = (phoneToTest) => {
    /**
     * Phone Number Combinations - 3 Cases to test
     * Country Key : +966 or 966
     * Full Phone Number example : +966504164474
     * Starts with 5 = 5-08657107 -> 8 digits left
     * Starts with 05 = 05-08657107 -> 8 digits left
     * Starts with 966 = 966-508657107 -> 9 digits left 
     */
    var key = "966";
    let phoneNumber = phoneToTest.trim();
    if (phoneNumber.startsWith("966") && phoneNumber.slice(3).length == 9) {

        return { valid: true, phoneNumber: key + phoneNumber.slice(3) }

    } else if (phoneNumber.startsWith("05") && phoneNumber.length == 10) {
        return { valid: true, phoneNumber: key + phoneNumber.slice(1) }

    } else if (phoneNumber.startsWith("5") && phoneNumber.length == 9) {
        return { valid: true, phoneNumber: key + phoneNumber }
    }
    else {

        return { valid: false, phoneNumber: null };

    }
}

/**
 * STC Saudi Arabia mobile number validation
 * STC prefixes: 50, 51, 52, 53, 54, 56, 55, 57, 58, 59 (with country code 966 = 9665x)
 * @param {string} phoneToTest - Phone number to validate
 * @returns {object} - {valid: boolean, phoneNumber: string|null}
 */
export const validateStcPhone = (phoneToTest) => {
    const key = "966";
    let phoneNumber = phoneToTest.trim();
    
    // STC mobile prefixes in Saudi Arabia (without leading 0)
    const stcPrefixes = ['50','51','52', '53','54', '56', '55','57',  '58', '59'];
    
    // Case 1: Full number with country code 966 (should be 12 digits total)
    if (phoneNumber.startsWith("966") && phoneNumber.length == 12) {
        const localNumber = phoneNumber.slice(3); // Remove 966
        const prefix = localNumber.slice(0, 2); // Get first 2 digits (5x)
        
        if (stcPrefixes.includes(prefix)) {
            return { valid: true, phoneNumber: phoneNumber };
        }
    }
    
    // Case 2: Number starts with 0 (local format like 050, 053, etc.) - convert to international
    if (phoneNumber.startsWith("0") && phoneNumber.length == 10) {
        const prefix = phoneNumber.slice(1, 3); // Get digits after 0 (like "50" from "050")
        
        if (stcPrefixes.includes(prefix)) {
            return { valid: true, phoneNumber: key + phoneNumber.slice(1) }; // Remove leading 0, add 966
        }
    }
    
    // Case 3: Number without country code and without leading 0 (9 digits like 501234567)
    if (phoneNumber.length == 9) {
        const prefix = phoneNumber.slice(0, 2); // Get first 2 digits
        
        if (stcPrefixes.includes(prefix)) {
            return { valid: true, phoneNumber: key + phoneNumber };
        }
    }
    
    return { valid: false, phoneNumber: null };
}
